<div #wizardContainer class="add-camera-result"></div>
